import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Firebase from './firebase/Firebase';
import FirebaseContext from './firebase/FirebaseContext';

ReactDOM.render(
  <React.StrictMode>
    <FirebaseContext.Provider value={ new Firebase() }>
      <FirebaseContext.Consumer>
        { firebase => <App firebase={ firebase } /> }
      </FirebaseContext.Consumer>
    </FirebaseContext.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
